<template lang="pug">
.m-card
  .m-card-header-wrapper(
    :data-bs-toggle="source.marketId != 3 ? 'collapse' : null"
    :href="source.marketId != 3 ? '#collapse-match-' + index + source.marketId : null"
    role='button'
    :aria-expanded="source.marketId == 3 ? 'true' : 'false'"
    :aria-controls="'collapse-match-' + index + source.marketId"
  )
    efTimer(:source="source")
    .mainmarket-item-match
      .team1
        img.characters(:src="getImage(source.sportsId, source.matchBody[22])")
        span.name {{ source.homeTeam }}
      .vs
        img.img-fluid(src='images/vgame/vs.svg')
      .team2
        img.characters(:src="getImage(source.sportsId, source.matchBody[23])")
        span.name {{ source.awayTeam }}

  .m-card-body.collapse.show(
    v-if="source.marketId != 3"
    :id="'collapse-match-' + index + source.marketId"
  )
    .m-card-item
      .m-card-wrap
        .odds-wrapper
          .m-label-wrap
            .m-label {{ $tc("m.BT_HDP", 2) }}
          .odds-group
            .col
              template(v-if="details['hdp'] && details['hdp'][0] && details['hdp'][0][9] != 0 && details['hdp'][0][10] != 0 && details['hdp'][0][9] != '' && details['hdp'][0][10] != ''")
                OddsItem(:odds="details['hdp'][0]" :idx="details['hdp'][0][7] == 1 ? '10' : '9'" :typ="oddsType" dataType="1" :mode="'hdp'" count=0 :details="details" homeAway="1")
              template(v-else)
                OddsDisabled
            .col
              template(v-if="details['hdp'] && details['hdp'][0] && details['hdp'][0][9] != 0 && details['hdp'][0][10] != 0 && details['hdp'][0][9] != '' && details['hdp'][0][10] != ''")
                OddsItem(:odds="details['hdp'][0]" :idx="details['hdp'][0][7] == 1 ? '9' : '10'" :typ="oddsType" dataType="1" :mode="'hdp'" count=0 :details="details" homeAway="2")
              template(v-else)
                OddsDisabled
        template(v-if="[43, 44].includes(source.sportsId)")
          .odds-wrapper
            .m-label-wrap
              .m-label {{ $tc("m.BT_OU", 2) }}
            .odds-group
              .col
                template(v-if="details['ou'] && details['ou'][0] && details['ou'][0][11] != 0 && details['ou'][0][12] != 0 && details['ou'][0][11] != '' && details['ou'][0][12] != ''")
                  OddsItem(:odds="details['ou'][0]" idx=12 :typ="oddsType" dataType="1" :mode="'ou'" label="over" count=0 :details="details" homeAway="1")
                template(v-else)
                  OddsDisabled
              .col
                template(v-if="details['ou'] && details['ou'][0] && details['ou'][0][11] != 0 && details['ou'][0][12] != 0 && details['ou'][0][11] != '' && details['ou'][0][12] != ''")
                  OddsItem(:odds="details['ou'][0]" idx=11 :typ="oddsType" dataType="1" :mode="'ou'" label="under" count=0 :details="details" homeAway="2")
                template(v-else)
                  OddsDisabled
        template(v-if="[42].includes(source.sportsId)")
          .odds-wrapper
            .m-label-wrap
              .m-label {{ $tc("m.BT_OE", 2) }}
            .odds-group
              .col
                template(v-if="details['oe'] && details['oe'][0] && details['oe'][0][5] != 0 && details['oe'][0][5] != ''")
                  OddsItem(:odds="details['oe'][0]" idx=5 :typ="oddsType" dataType="2" mode="oe" label="odd" homeAway="1")
                template(v-else)
                  OddsDisabled
              .col
                template(v-if="details['oe'] && details['oe'][0] && details['oe'][0][7] != 0 && details['oe'][0][7] != ''")
                  OddsItem(:odds="details['oe'][0]" idx=7 :typ="oddsType" dataType="2" mode="oe" label="even" homeAway="2")
                template(v-else)
                  OddsDisabled

</template>

<script>
import config from "@/config";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default{
  components: {
    efTimer: () => import("@/components/mobile/efight/efTimer"),
    OddsItem: () => import("@/components/mobile/main/xitem/oddsItem"),
    OddsDisabled: () => import("@/components/mobile/main/xitem/oddsDisabled")
  },
  mixins: [mixinHDPOUOdds],
  props: {
    source: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: {
    newFeatures() {
      return config.newFeatures
    }
  },
  methods: {
    getImage(s, img) {
      return config.resourceImgUrl + "/ef/" + (this.newFeatures ? 'uat/' : 'prod/') + s + "/" + img + ".png";
    }
  }
}
</script>